import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function ChartIncreasing(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg viewBox='0 0 32 32' {...props}>
      <path
        d='M3 3C3 2.44772 3.44772 2 4 2C4.55228 2 5 2.44772 5 3V27H28C28.5523 27 29 27.4477 29 28C29 28.5523 28.5523 29 28 29H4C3.44772 29 3 28.5523 3 28V3Z'
        fill='currentColor'
      />
      <path
        d='M8.29297 20.707C8.68349 21.0976 9.31651 21.0976 9.70703 20.707L16 14.4141L19.293 17.707L19.3691 17.7754C19.7619 18.0958 20.3409 18.0732 20.707 17.707L27 11.4141V13C27 13.5523 27.4477 14 28 14C28.5523 14 29 13.5523 29 13V9.00001C29 8.44773 28.5523 8.00001 28 8.00001H24C23.4477 8.00001 23 8.44773 23 9.00001C23 9.5523 23.4477 10 24 10H25.5859L20 15.586L16.707 12.293C16.3165 11.9025 15.6835 11.9025 15.293 12.293L8.29297 19.293C7.90245 19.6835 7.90245 20.3165 8.29297 20.707Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
